export const extractUnreadPositionGuids = (
    response: Record<string, unknown> | null | undefined
): string[] => {
    if (!response || typeof response !== 'object') {
        return [];
    }

    const unreadPositionGuids = response.data;

    if (!Array.isArray(unreadPositionGuids)) {
        return [];
    }

    return unreadPositionGuids
        .map((guid) => String(guid).trim())
        .filter((guid) => guid.length > 0);
};
